<template>
  <div id="app" :key="$i18n.locale">
    <headers />
    <router-view></router-view>
    <transition name="fade">
      <!-- 返回顶部按钮 固定右下角 -->
      <div
        class="back-top"
        v-show="showTopBtn"
        @click="backToTop"
        v-if="!$isMobile"
      >
        <img src="./assets/img/top@2x.png" alt="" />
        <div class="top-icon">
          <img src="./assets/img/jt.png" alt="" />
          <span>Top</span>
        </div>
      </div>
    </transition>
    <foots />
  </div>
</template>
<script>
import foots from "@/components/foots.vue";
import headers from "@/components/headers.vue";
export default {
  components: { headers, foots },

  data() {
    return {
      showTopBtn: false, // 是否显示返回顶部按钮
    };
  },
  mounted() {
    // 监听页面滚动事件
    window.addEventListener("scroll", this.scrollHandler);
  },
  beforeDestroy() {
    // 离开页面销毁监听，防止内存泄漏
    window.removeEventListener("scroll", this.scrollHandler);
  },
  methods: {
    // 滚动监听：滚动超过150px显示按钮
    scrollHandler() {
      this.showTopBtn = window.scrollY > 150;
    },
    // 回到顶部
    backToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth", // 平滑滚动，去掉就是瞬间回弹
      });
    },
  },
};
</script>

<style lang="scss">
/* 1. 淡入淡出过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  /* 底部向上滑入效果 */
  transform: translateY(20px);
}
.back-top {
  position: fixed;
  right: 0px;
  bottom: 30px;
  color: #fff;
  cursor: pointer;
  z-index: 999;
  img {
    width: 50px;
    height: 41px;
  }
  .top-icon {
    width: 50px;
    height: 41px;
    position: absolute;
    top: 0px;
    left: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 12px;
    z-index: 999;
    img {
      width: 19px;
      height: 10px;
    }
  }
}

* {
  margin: 0;
  padding: 0;
}
body,
html {
  width: 100%;
  overflow-x: auto;
  padding: 0 !important;
}
</style>
